import initialState from "./initialState";
import { createReducer, checkNested } from "../reducer_utils";

const getFetchingMessage = action => {
  const { resourceType, domain, orderBy, orderDir } = action;
  const messages = {
    overview: `fetch_overview_${domain}`,
    backlinks: `fetch_backlinks_${domain}_${orderBy}_${orderDir}`,
    referring_domains: `fetch_referring_domains_${domain}_${orderBy}_${orderDir}`,
    top_anchors: `fetch_top_anchors_${domain}_${orderBy}_${orderDir}`,
    tld_distribution: `fetch_tld_distribution_${domain}_${orderBy}_${orderDir}`,
    top_countries: `fetch_top_countries_${domain}_${orderBy}_${orderDir}`
  };

  return messages[resourceType] || "";
};

const addNetworkActivityMessage = (networkActivity, action) => [...networkActivity, getFetchingMessage(action)];

const removeNetworkActivityMessage = (networkActivity, msgType, action) => {
  return networkActivity.filter(msg => msg !== getFetchingMessage(msgType, action));
};

const getUpdatedResource = (state, action) => {
  const { resourceType, domain, orderBy, orderDir, response } = action;
  const sortKey = `${orderBy}_${orderDir}`;

  let results = {
    data: response[resourceType],
    has_more: response["has_more"]
  };

  if (checkNested(state[resourceType], domain, sortKey)) {
    results["data"] = [...state[resourceType][domain][sortKey]["data"], ...response[resourceType]];
  }

  return {
    ...state[resourceType],
    [domain]: { ...state[resourceType][domain], [sortKey]: results }
  };
};

const fetchResourceInProgress = (state, action) => ({
  ...state,
  network_activity: addNetworkActivityMessage(state.network_activity, action)
});

const fetchResourceSuccess = (state, action) => ({
  ...state,
  network_activity: removeNetworkActivityMessage(state.network_activity, action),
  [action.resourceType]: getUpdatedResource(state, action)
});

const fetchOverviewSuccess = (state, action) => ({
  ...state,
  network_activity: removeNetworkActivityMessage(state.network_activity, action),
  overview: { ...state.overview, [action.domain]: action.overview }
});

const fetchResourceFailed = (state, action) => ({
  ...state,
  network_activity: removeNetworkActivityMessage(state.network_activity, action)
});

const logout = (state, _) => ({ ...state, ...initialState });

const backlinksReducer = createReducer(initialState, {
  FETCH_BACKLINKS_OVERVIEW_IN_PROGRESS: fetchResourceInProgress,
  FETCH_BACKLINKS_OVERVIEW_SUCCESS: fetchOverviewSuccess,
  FETCH_BACKLINKS_OVERVIEW_FAILED: fetchResourceFailed,

  FETCH_BACKLINKS_IN_PROGRESS: fetchResourceInProgress,
  FETCH_BACKLINKS_SUCCESS: fetchResourceSuccess,
  FETCH_BACKLINKS_FAILED: fetchResourceFailed,

  FETCH_REFERRING_DOMAINS_IN_PROGRESS: fetchResourceInProgress,
  FETCH_REFERRING_DOMAINS_SUCCESS: fetchResourceSuccess,
  FETCH_REFERRING_DOMAINS_FAILED: fetchResourceFailed,

  FETCH_TOP_ANCHORS_IN_PROGRESS: fetchResourceInProgress,
  FETCH_TOP_ANCHORS_SUCCESS: fetchResourceSuccess,
  FETCH_TOP_ANCHORS_FAILED: fetchResourceFailed,

  FETCH_TOP_COUNTRIES_IN_PROGRESS: fetchResourceInProgress,
  FETCH_TOP_COUNTRIES_SUCCESS: fetchResourceSuccess,
  FETCH_TOP_COUNTRIES_FAILED: fetchResourceFailed,

  FETCH_TLD_DISTRIBUTION_IN_PROGRESS: fetchResourceInProgress,
  FETCH_TLD_DISTRIBUTION_SUCCESS: fetchResourceSuccess,
  FETCH_TLD_DISTRIBUTION_FAILED: fetchResourceFailed,

  LOGOUT: logout
});

export default backlinksReducer;
